import React, { useEffect } from 'react';
import BoligmappaPlusLanding from '@componentsV2/BoligmappaPlusLanding';
import { withStyles } from '@material-ui/core';
import useDesktop from '@hooksV2/useDesktop';
import styles from './style';
import useDashboardLinkPrefix from '../../../../hooks/useDashboardLinkPrefix';
import { boligmappaPlusSinglePayment } from '../../../../api/boligmappaPlus';
import useFetchEffect from '../../../../hooks/useFetchEffect';
import { fetchPropertyOwner as apiFetchPropertyOwner } from '../../../../api/propertyowners';
import { getPropertyOwnerSubscriptionStatus } from '../../../../utils/properties';
import matomo from '../../../../utils/matomo';

const BoligmappaPlusPage = ({ classes }) => {
  const isDesktop = useDesktop();
  const dashboardLinkPrefix = useDashboardLinkPrefix();

  const { data: propertyOwner } = useFetchEffect({
    initialDataState: {},
    defaultDataState: {},
    initialFetchingState: true,
    apiFetchFunction: apiFetchPropertyOwner,
  });

  const isBoligmappaPlusSub = getPropertyOwnerSubscriptionStatus(propertyOwner);

  const onActionClick = async (type) => {
    const redirectUrl = window.location.href;
    const [error, response] = await boligmappaPlusSinglePayment(
      type,
      redirectUrl
    );
    if (!error && response) {
      window.location.href = response.response.agreementFrontendUrl;
    }
  };
  useEffect(() => {
    matomo.clickEvent({
      category: 'Boligmappa+',
      action: 'Rendered CTA',
      name: 'Rendered CTA on Boligmappa+ Landing Page',
    });
  }, []);
  return (
    <div className={classes.page}>
      <BoligmappaPlusLanding
        isBoligmappaPlusSub={isBoligmappaPlusSub}
        isDesktop={isDesktop}
        dashboardLinkPrefix={dashboardLinkPrefix}
        onActionClick={onActionClick}
      />
    </div>
  );
};

export default withStyles(styles)(BoligmappaPlusPage);
